<template>
  <div>
    <b-row>
      <b-col>
        <span style="font-size: 1.2em; font-weight: 700; color: #233c7c;">
          Additional Details
        </span>
      </b-col>
    </b-row>

    <hr style="border-top: 2px solid #dddddd;">

    <b-row>
      <b-col>
        <font-awesome-icon icon="check" style="color: green;" /> Refundable & Reschedule Available
        <br>
        <font-awesome-icon icon="check" style="color: green;" /> Flexible Itinerary
        <br>
        <font-awesome-icon icon="check" style="color: green;" /> Photo Service
        <br>
        <font-awesome-icon icon="times" style="color: red;" /> Ticket for Tourist Attraction
        <br>
        <font-awesome-icon icon="times" style="color: red;" /> Transportation fee
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_AdditionalDetail',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/AdditionalDetail/AdditionalDetail.vue